import React, { Component } from 'react';

export default class ItemPage0 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
            <div>
                No page found for item
            </div>
         );
    }
}